import { c as _c } from "react/compiler-runtime";
import { ProductCard } from '@/components/product/ProductCard';
import type { ProductCardProduct } from '@/components/product/ProductCard';
interface RelatedProductsProps {
  products: ProductCardProduct[];
}
export function RelatedProducts(t0) {
  const $ = _c(5);
  const {
    products
  } = t0;
  if (products.length === 0) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="related-products-header">Related Products (including Product Options)</div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== products) {
    t2 = products.map(_temp);
    $[1] = products;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <section id="related-products" className="related-products-section">{t1}<div className="product-grid">{t2}</div></section>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp(product) {
  return <ProductCard key={product.id} product={product} />;
}